import React, { useEffect, useState } from "react";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import glLogo from "../../assets/Logo/gl-funnel-login-logo.svg";
import loginService from "../Services/LoginService";
import axios from "axios";
import { getIcons, getLogos } from "../Constant/Constant";
import { showSuccessToast } from "../Constant/Notification";
import { ToastContainer } from "react-toastify";
import CustomInput from "../common/CustomInput";
import useLogin from "../../hooks/useLogin";

const ResetPassword = () => {
  const logo = getLogos();
  const images = getIcons();

  const {
    email,
    formErrors,
    isLoading,

    handleEmailChange,
    handleForgotPassword,
    navigate,
  } = useLogin();

  const handleBackToLogin = () => {
    navigate("/login");
  };

  //   const handleReset = async (e) => {
  //     e.preventDefault();
  //     if (email !== "") {
  //       const resetData = { email: email };

  //       try {
  //         await loginService.resetPassword(resetData);
  //         showSuccessToast("Please check your email. A link has been sent to your email address.");

  //         setEmail("")
  //  setTimeout(()=>{
  //   navigate('/login')
  //  },2000)
  //        // navigate("/login");
  //       } catch (error) {
  //         console.error(error);
  //         setInvalidInput(true);
  //       }
  //     } else {
  //       setInvalidInput(true);
  //     }
  //   };

  return (
    <>
      <ToastContainer />
      <div className="grid grid-cols-2 w-full overflow-hidden">
        <div className="w-full   h-screen bg-gradient-to-b from-[#399C7A] to-[#14362A] flex items-center  justify-center">
          <img className="" src={images.loginImage} alt="" />
        </div>

        <div className="w-full bg-slate-100 flex justify-center">
          <div className="absolute right-4 ">
            <img className="p-5 w-36 " src={logo.clientLoginLogo} alt="" />
          </div>
          <div className="mt-52 mx-56  custom-xl:mt-72   3xl:mt-72 2xl:mt-72 xl:mt-72 lg:mt-36 4xl:mt-96  relative">
            <form
              className="flex flex-col gap-4  xl:gap-5 "
              onSubmit={handleForgotPassword}
            >
              <h1 className="font-bold 2xl:text-2xl lg:text-xl 3xl:text-3xl custom-xl:text-2xl 4xl:text-4xl ">
                Forgot Your password?
              </h1>

              <label
                className="font- text-xl lg:text-sm 3xl:text-xl  custom-xl:text-lg  4xl:text-3xl"
                htmlFor="login"
              >
                Enter your mail ID below, we will send you a password reset link
              </label>

              <CustomInput
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter your email"
              />

              {/* <input
                type="text"
                className={`shadow appearance-none focus:outline-none lg:text-sm 3xl:text-xl  custom-xl:text-lg  4xl:text-3xl  border rounded 3xl:w-[530px] 4xl:w-[770px] 4xl:h-16 3xl:h-12 xl:w-[398px] custom-xl:w-[398px] 2xl:w-[398px] lg:w-72 h-10 px-3 text-gray-700 ${
                  invalidInput && "border-red-500"
                }`} // Apply border-red-500 class if invalidInput is true
                placeholder={invalidInput.email || "Email"}
                value={email}
                onChange={handleEmail}
              /> */}
              <button
                disabled={!email || isLoading}
                className={`
    text-center text-lg 3xl:text-xl text-white rounded-md shadow
    3xl:w-[530px] 3xl:h-12 4xl:w-[630px] 4xl:h-16 xl:w-[398px]
    custom-xl:w-[398px] 2xl:w-[398px] lg:w-72 h-10
    ${
      !email || isLoading
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-customGreen hover:bg-green-600"
    }
  `}
              >
                {isLoading ? "Sending..." : "Send Reset Link"}
              </button>
              {/* <div
                className="text-[#007AFF] w-full flex justify-end cursor-pointer text-lg"
                onClick={handleForgetPassword}
                >
                Forgot password?
              </div> */}
              <div
                className="text-[#007AFF] text-end w-full lg:text-sm xl:text-lg  custom-xl:text-lg  4xl:text-2xl cursor-pointer text-sm 3xl:text-lg 3xl:w-[530px] 4xl:w-[770px] xl:w-[398px] custom-xl:w-[398px] 2xl:w-[398px]"
                onClick={handleBackToLogin}
              >
                Return to Login
              </div>

              {formErrors?.general && ( // Render message if invalidInput is true
                <div className="text-red-500 text-center text-sm">
                  {formErrors.general}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
